import { render, staticRenderFns } from "./CreateOrUpdateApplicationType.vue?vue&type=template&id=24cbced2&scoped=true&"
import script from "./CreateOrUpdateApplicationType.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateApplicationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbced2",
  null
  
)

export default component.exports